import { Component, HostBinding } from '@angular/core';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'suka-frame',
  template: `
    <div class="frame__header">
      <ng-content select="suka-topbar"></ng-content>
    </div>

    <ng-template #navigationTemplate>
       <ng-content select="suka-navigation"></ng-content>
    </ng-template>

    <div class="frame__nav" *ngIf="!mobile">
      <ng-container *ngTemplateOutlet="navigationTemplate"></ng-container>
    </div>

    <div class="frame__main">
      <ng-content select="suka-page"></ng-content>
    </div>

    <div class="frame__mobile-nav" *ngIf="mobile">
      <suka-mobile-navigation>
        <ng-container *ngTemplateOutlet="navigationTemplate"></ng-container>
      </suka-mobile-navigation>
    </div>

    <ng-content></ng-content>
  `
})
export class Frame {
  @HostBinding('class.frame') baseClass = true;
  @HostBinding('class.frame--mobile') mobile = false;

  constructor(breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe('(max-width: 768px)').subscribe(result => {
      if (result.matches) {
        this.activateHandsetLayout();
      } else {
        this.activateDesktopLayout();
      }
    });
  }

  activateHandsetLayout() {
    this.mobile = true;
  }

  activateDesktopLayout() {
    this.mobile = false;
  }
}
